import { t } from "i18next";

const BILLING_QUESTIONS_EMAIL = "billing@certn.co";
const REMITTANCE_EMAIL = "remittances@certn.co";

export function InvoiceContactEmails() {
  return (
    <>
      {t("Questions: {{email}}", { email: BILLING_QUESTIONS_EMAIL })}
      <br />
      {t("Remittances: {{email}}", { email: REMITTANCE_EMAIL })}
      <br />
    </>
  );
}
